module.exports = __webpack_public_path__ + "static/media/Group_3649.56e24f41.png";